export const initShopifyProductReviews = () => {
    if (!globalThis.SPR) {
        return;
    }
    globalThis.SPR.registerCallbacks();
    globalThis.SPR.initRatingHandler();
    globalThis.SPR.initDomEls();
    globalThis.SPR.loadProducts();
    globalThis.SPR.loadBadges();
};
const ProductReviews = {
    initShopifyProductReviews,
};
export default ProductReviews;
